(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.en = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'No data found'
      },
      combobox: {
        placeholder: 'Select',
        searchPlaceholder: 'Search'
      },
      datepicker: {
        apply: 'Apply',
        clearSelection: 'Clear',
        pickADays: 'Select days',
        prevYear: 'Previous Year',
        nextYear: 'Next Year',
        prevMonth: 'Previous Month',
        nextMonth: 'Next Month',
        year: '',
        month1: 'January',
        month2: 'February',
        month3: 'March',
        month4: 'April',
        month5: 'May',
        month6: 'June',
        month7: 'July',
        month8: 'August',
        month9: 'September',
        month10: 'October',
        month11: 'November',
        month12: 'December',
        weeks: {
          sun: 'Sun',
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'May',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Oct',
          nov: 'Nov',
          dec: 'Dec'
        },
        pickADay: 'Select a day'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'No data found'
      },
      filepicker: {
        browse: 'Browse',
        select: 'Select a file'
      },
      filter: {
        apply: 'Apply',
        cancel: 'Cancel',
        filterButton: 'Filter',
        reset: 'Reset filters',
        resetDefault: 'Reset to default'
      },
      search: {
        noDataMessage: 'No data found'
      },
      'multi-search': {
        'separator-and': 'AND',
        'search-button': 'Search',
        'search-placeholder': 'Search by name'
      },
      select: {
        all: 'All',
        clearSelection: 'Clear selection',
        noMatch: 'No data found',
        noData: 'No data',
        placeholder: 'Select',
        item: 'item(s)',
        selected: 'selected',
        found: 'found'
      },
      upload: {
        browseButton: 'Browse',
        text: 'Drag and drop files to upload, or click "Browse"',
        tip: 'You can upload 10 files up to 25 MB each'
      },
      table: {
        emptyText: 'No Data'
      },
      tree: {
        emptyText: 'No Data'
      }
    }
  };
  _exports.default = _default;
});